import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  subgroups: [],
  subgroup: {},
  subgroupIds: [],
};

export const getSubgroups = createAsyncThunk(
  'subgroups/getSubgroups',
  async () => {
    const { data } = await api.get('/accounts/subgroups');

    return data;
  },
);

export const getSubgroupIds = createAsyncThunk(
  'subgroups/getSubgroupIds',
  async () => {
    const { data } = await api.get('/accounts/subgroups/ids');

    return data;
  },
);

export const getSubgroup = createAsyncThunk(
  'subgroups/getSubgroup',
  async id => {
    const { data } = await api.get(`/accounts/subgroups/${id}`);

    return data;
  },
);

export const addSubgroup = createAsyncThunk(
  'subgroups/addSubgroup',
  async data => {
    const { data: subgroup } = await api.post('/accounts/subgroups', data);

    return subgroup;
  },
);

export const editSubgroup = createAsyncThunk(
  'subgroups/editSubgroup',
  async ({ id, data }) => {
    const { data: subgroup } = await api.put(`/accounts/subgroups/${id}`, data);

    return subgroup;
  },
);

const subgroups = createSlice({
  name: 'subgroups',

  initialState,

  reducers: {
    clearSubgroups: draft => {
      draft.subgroups = initialState.subgroups;
    },

    clearSubgroup: draft => {
      draft.subgroup = initialState.subgroup;
    },

    clearSubgroupIds: draft => {
      draft.subgroupIds = initialState.subgroupIds;
    },
  },

  extraReducers: builder => {
    builder.addCase(getSubgroups.fulfilled, (draft, { payload }) => {
      draft.subgroups = payload;
    });

    builder.addCase(getSubgroup.fulfilled, (draft, { payload }) => {
      draft.subgroup = payload;
    });

    builder.addCase(addSubgroup.fulfilled, (draft, { payload }) => {
      draft.subgroups.push(payload);
    });

    builder.addCase(editSubgroup.fulfilled, (draft, { payload }) => {
      const index = draft.subgroups.findIndex(el => el.id === payload.id);

      draft.subgroups[index] = payload;
    });

    builder.addCase(getSubgroupIds.fulfilled, (draft, { payload }) => {
      draft.subgroupIds = payload;
    });

    builder.addMatcher(
      isAnyOf(
        getSubgroups.rejected,
        getSubgroup.rejected,
        addSubgroup.rejected,
        editSubgroup.rejected,
        getSubgroupIds.rejected,
      ),
      (_Draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearSubgroups, clearSubgroup, clearSubgroupIds } =
  subgroups.actions;

export default subgroups.reducer;
